import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=28b77bd6&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b77bd6')) {
      api.createRecord('28b77bd6', component.options)
    } else {
      api.reload('28b77bd6', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=28b77bd6&", function () {
      api.rerender('28b77bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24fXGZ4EUs7Gy/JS/offershelp.vue"
export default component.exports